import axios from "axios";
import { GET_USER_LIST, MAKE_USER, DELETE_KEY, DELETE_USER, USER_UPDATE_AUTOCHK} from "../constant";
const { decorate, observable, action } = require("mobx");
class User {
  user = null;
  charge = false;
  error;
  userList = [];

  setUser(user) {
    this.user = user;
    this.getUserList();
  }

  setError(error) {
    this.error = error;
  }
  setCharge(value) {
    this.charge = value;
  }

  Logout() {
    this.user = null;
  }

  async getUserList() {
    let response = await axios.get(GET_USER_LIST);
    let data = await response.data;
    this.userList = data;
  }

  async makeUser(userid, userpw, username) {
    try {
      let response = await axios.post(MAKE_USER, {
        userid: userid,
        userpw: userpw,
        username: username,
      });
      await this.getUserList();
    } catch (error) {
      throw error;
    }
  }

  async deleteUser(userid) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      let response = await axios.delete(
        DELETE_USER + userid,
        {
          data: { deleteKey: DELETE_KEY },
        },
        config
      );
      await this.getUserList();
    } catch (error) {
      throw error;
    }
  }
  async updateAutoChk(userid, lName, chk){
    try{
        this.isLoading = true;
        let response = await axios.put(USER_UPDATE_AUTOCHK,{
          userid: userid,  
          lName: lName,
          autoChk: chk,
        }); 
        await this.getUserList();
        this.isLoading = false;
    }catch(error){
        this.isLoading = false;
        throw error;
    }
  }
}

decorate(User, {
  user: observable,
  userList: observable,
  charge: observable,
  setUser: action,
  setError: action,
  setCharge: action,
});

const user = new User();
export default user;
